import { appShareCardFileName, appShareCardPath } from '../../domain/share/appShare';
import { fetchShareImageFile } from './shareImageFile';

/**
 * Load the app's invitation card as a `File`, in the language on screen
 * (SPEC-020).
 *
 * The counterpart to `plantSheetFile.js`, over the same fetch. The `portrait`
 * shape is the default because this is the file a person hands to another
 * person: 4:5 is what a message bubble and a story render whole. The `unfurl`
 * shape exists for the document head and is never fetched by the app.
 */

export async function fetchAppShareCardFile({ languageCode, shape = 'portrait' } = {}, options = {}) {
    return fetchShareImageFile(
        {
            url: appShareCardPath(languageCode, shape),
            fileName: appShareCardFileName(),
            type: 'image/jpeg',
        },
        options,
    );
}
